// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StoreRouteImport } from './routes/store'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PostmenopauseRouteImport } from './routes/postmenopause'
import { Route as PerimenopauseRouteImport } from './routes/perimenopause'
import { Route as NewsRouteImport } from './routes/news'
import { Route as MenopauseGuideRouteImport } from './routes/menopause-guide'
import { Route as MenopauseRouteImport } from './routes/menopause'
import { Route as MedicalResetRouteImport } from './routes/medical-reset'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DisclaimerRouteImport } from './routes/disclaimer'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ConsumerHealthPrivacyRouteImport } from './routes/consumer-health-privacy'
import { Route as ConfirmEmailRouteImport } from './routes/confirm-email'
import { Route as ChoosePlanRouteImport } from './routes/choose-plan'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as EsIndexRouteImport } from './routes/es.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as ScoreTodayRouteImport } from './routes/score.today'
import { Route as GuidePerimenopauseTestRouteImport } from './routes/guide.perimenopause-test'
import { Route as GuideOuraRingMenopauseRouteImport } from './routes/guide.oura-ring-menopause'
import { Route as GuideMenopauseAgeCalculatorRouteImport } from './routes/guide.menopause-age-calculator'
import { Route as GuideHeartPalpitationsRouteImport } from './routes/guide.heart-palpitations'
import { Route as GuideFshLevelsRouteImport } from './routes/guide.fsh-levels'
import { Route as Guide34SymptomsRouteImport } from './routes/guide.34-symptoms'
import { Route as EsTiendaRouteImport } from './routes/es.tienda'
import { Route as EsTerminosRouteImport } from './routes/es.terminos'
import { Route as EsPrivacidadRouteImport } from './routes/es.privacidad'
import { Route as EsNoticiasRouteImport } from './routes/es.noticias'
import { Route as EsMedicalResetRouteImport } from './routes/es.medical-reset'
import { Route as EsGuiaMenopausiaRouteImport } from './routes/es.guia-menopausia'
import { Route as EsAvisoLegalRouteImport } from './routes/es.aviso-legal'
import { Route as DevSampleReportRouteImport } from './routes/dev.sample-report'
import { Route as DevPreviewMyReportRouteImport } from './routes/dev.preview-my-report'
import { Route as DevPreviewAnnualSummaryRouteImport } from './routes/dev.preview-annual-summary'
import { Route as AdminTestRouteImport } from './routes/admin.test'
import { Route as AdminBodySignalRouteImport } from './routes/admin.body-signal'
import { Route as StoreSlugRouteImport } from './routes/store.$slug'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const StoreRoute = StoreRouteImport.update({
            id: '/store',path: '/store',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PostmenopauseRoute = PostmenopauseRouteImport.update({
            id: '/postmenopause',path: '/postmenopause',getParentRoute: () => rootRouteImport
          })
const PerimenopauseRoute = PerimenopauseRouteImport.update({
            id: '/perimenopause',path: '/perimenopause',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const MenopauseGuideRoute = MenopauseGuideRouteImport.update({
            id: '/menopause-guide',path: '/menopause-guide',getParentRoute: () => rootRouteImport
          })
const MenopauseRoute = MenopauseRouteImport.update({
            id: '/menopause',path: '/menopause',getParentRoute: () => rootRouteImport
          })
const MedicalResetRoute = MedicalResetRouteImport.update({
            id: '/medical-reset',path: '/medical-reset',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DisclaimerRoute = DisclaimerRouteImport.update({
            id: '/disclaimer',path: '/disclaimer',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ConsumerHealthPrivacyRoute = ConsumerHealthPrivacyRouteImport.update({
            id: '/consumer-health-privacy',path: '/consumer-health-privacy',getParentRoute: () => rootRouteImport
          })
const ConfirmEmailRoute = ConfirmEmailRouteImport.update({
            id: '/confirm-email',path: '/confirm-email',getParentRoute: () => rootRouteImport
          })
const ChoosePlanRoute = ChoosePlanRouteImport.update({
            id: '/choose-plan',path: '/choose-plan',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const EsIndexRoute = EsIndexRouteImport.update({
            id: '/es/',path: '/es/',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const ScoreTodayRoute = ScoreTodayRouteImport.update({
            id: '/score/today',path: '/score/today',getParentRoute: () => rootRouteImport
          })
const GuidePerimenopauseTestRoute = GuidePerimenopauseTestRouteImport.update({
            id: '/guide/perimenopause-test',path: '/guide/perimenopause-test',getParentRoute: () => rootRouteImport
          })
const GuideOuraRingMenopauseRoute = GuideOuraRingMenopauseRouteImport.update({
            id: '/guide/oura-ring-menopause',path: '/guide/oura-ring-menopause',getParentRoute: () => rootRouteImport
          })
const GuideMenopauseAgeCalculatorRoute = GuideMenopauseAgeCalculatorRouteImport.update({
            id: '/guide/menopause-age-calculator',path: '/guide/menopause-age-calculator',getParentRoute: () => rootRouteImport
          })
const GuideHeartPalpitationsRoute = GuideHeartPalpitationsRouteImport.update({
            id: '/guide/heart-palpitations',path: '/guide/heart-palpitations',getParentRoute: () => rootRouteImport
          })
const GuideFshLevelsRoute = GuideFshLevelsRouteImport.update({
            id: '/guide/fsh-levels',path: '/guide/fsh-levels',getParentRoute: () => rootRouteImport
          })
const Guide34SymptomsRoute = Guide34SymptomsRouteImport.update({
            id: '/guide/34-symptoms',path: '/guide/34-symptoms',getParentRoute: () => rootRouteImport
          })
const EsTiendaRoute = EsTiendaRouteImport.update({
            id: '/es/tienda',path: '/es/tienda',getParentRoute: () => rootRouteImport
          })
const EsTerminosRoute = EsTerminosRouteImport.update({
            id: '/es/terminos',path: '/es/terminos',getParentRoute: () => rootRouteImport
          })
const EsPrivacidadRoute = EsPrivacidadRouteImport.update({
            id: '/es/privacidad',path: '/es/privacidad',getParentRoute: () => rootRouteImport
          })
const EsNoticiasRoute = EsNoticiasRouteImport.update({
            id: '/es/noticias',path: '/es/noticias',getParentRoute: () => rootRouteImport
          })
const EsMedicalResetRoute = EsMedicalResetRouteImport.update({
            id: '/es/medical-reset',path: '/es/medical-reset',getParentRoute: () => rootRouteImport
          })
const EsGuiaMenopausiaRoute = EsGuiaMenopausiaRouteImport.update({
            id: '/es/guia-menopausia',path: '/es/guia-menopausia',getParentRoute: () => rootRouteImport
          })
const EsAvisoLegalRoute = EsAvisoLegalRouteImport.update({
            id: '/es/aviso-legal',path: '/es/aviso-legal',getParentRoute: () => rootRouteImport
          })
const DevSampleReportRoute = DevSampleReportRouteImport.update({
            id: '/dev/sample-report',path: '/dev/sample-report',getParentRoute: () => rootRouteImport
          })
const DevPreviewMyReportRoute = DevPreviewMyReportRouteImport.update({
            id: '/dev/preview-my-report',path: '/dev/preview-my-report',getParentRoute: () => rootRouteImport
          })
const DevPreviewAnnualSummaryRoute = DevPreviewAnnualSummaryRouteImport.update({
            id: '/dev/preview-annual-summary',path: '/dev/preview-annual-summary',getParentRoute: () => rootRouteImport
          })
const AdminTestRoute = AdminTestRouteImport.update({
            id: '/admin/test',path: '/admin/test',getParentRoute: () => rootRouteImport
          })
const AdminBodySignalRoute = AdminBodySignalRouteImport.update({
            id: '/admin/body-signal',path: '/admin/body-signal',getParentRoute: () => rootRouteImport
          })
const StoreSlugRoute = StoreSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => StoreRoute
          })





const StoreRouteChildren = {
  StoreSlugRoute: StoreSlugRoute
}

const StoreRouteWithChildren = StoreRoute._addFileChildren(StoreRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AppRoute: AppRoute,ChoosePlanRoute: ChoosePlanRoute,ConfirmEmailRoute: ConfirmEmailRoute,ConsumerHealthPrivacyRoute: ConsumerHealthPrivacyRoute,CookiesRoute: CookiesRoute,DisclaimerRoute: DisclaimerRoute,ForgotPasswordRoute: ForgotPasswordRoute,MedicalResetRoute: MedicalResetRoute,MenopauseRoute: MenopauseRoute,MenopauseGuideRoute: MenopauseGuideRoute,NewsRoute: NewsRoute,PerimenopauseRoute: PerimenopauseRoute,PostmenopauseRoute: PostmenopauseRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,StoreRoute: StoreRouteWithChildren,TermsRoute: TermsRoute,AdminBodySignalRoute: AdminBodySignalRoute,AdminTestRoute: AdminTestRoute,DevPreviewAnnualSummaryRoute: DevPreviewAnnualSummaryRoute,DevPreviewMyReportRoute: DevPreviewMyReportRoute,DevSampleReportRoute: DevSampleReportRoute,EsAvisoLegalRoute: EsAvisoLegalRoute,EsGuiaMenopausiaRoute: EsGuiaMenopausiaRoute,EsMedicalResetRoute: EsMedicalResetRoute,EsNoticiasRoute: EsNoticiasRoute,EsPrivacidadRoute: EsPrivacidadRoute,EsTerminosRoute: EsTerminosRoute,EsTiendaRoute: EsTiendaRoute,Guide34SymptomsRoute: Guide34SymptomsRoute,GuideFshLevelsRoute: GuideFshLevelsRoute,GuideHeartPalpitationsRoute: GuideHeartPalpitationsRoute,GuideMenopauseAgeCalculatorRoute: GuideMenopauseAgeCalculatorRoute,GuideOuraRingMenopauseRoute: GuideOuraRingMenopauseRoute,GuidePerimenopauseTestRoute: GuidePerimenopauseTestRoute,ScoreTodayRoute: ScoreTodayRoute,AdminIndexRoute: AdminIndexRoute,EsIndexRoute: EsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)